<template>
    <div class="searchPage">
        <van-search
            v-model="inputValue"
            placeholder="全局搜索"
            >
            <template #left-icon>
                <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
            </template>
        </van-search>
    </div>
</template>

<script>
import { Search } from 'vant';
export default {
    components: {
        vanSearch: Search
    },
    data(){
        return {
            inputValue: ''
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped>
.searchPage{
    width: 100%;
    height: 100%;
    text-align: center;
}
</style>